import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ReturnStatement } from '@angular/compiler/src/output/output_ast';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/Task/Task.html'
})

export class TaskComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    public myTask: any[] = [];
    public myCustomer:any[]=[];
    public usersItems: any[] = [];
    public projectList:any[]=[];
    public PriorityItems: any[] = [];
    public StatusItems:any[]=[];
    public userTypeInfo: any[] = [];
    public taskTypeItems: any[] = [];
    public TaskList:any[]=[];
    public customerItem: any[] = [];
    public TaskItems: any[] = [];
    public ModuleList: any[] =[];
    public CheckList: any[] =[];
    public isAdd: boolean = true;
    public IsCreated  : boolean = true;
    public IsStatusOpen  : boolean = true;
    public IsCreatedBy  : boolean = false;
    public IsCompleted  : boolean = false;
    public IsSubmit  : boolean = true;
    active = true;
    filter: any = { 'TeamId': "", 'TypeId': "", 'Status': "" };
    public subscription: any;
    public showLoader = false;
    public isFormSubmitted: boolean = false;
    public Search: any = "";
    public edithide: boolean = true;
    public addhide: boolean = false;
    public greater = false;
    public actualDateGreater = false;
    public CheckListName:any;
    public SequenceId :any = 1;
    public addEditMTask: any = {};
    public TaskStrike : boolean = false;
    public editTaskId: any = 0;
    public TaskDetails:any ={ProjectId:"",ModuleId:"",TaskTypeId:"",AssignedTo:""};
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private activatedRoute: ActivatedRoute,
        private _Router: Router) {
            debugger;
        this.subscription =
            this.activatedRoute.queryParams.subscribe(
                (param: any) => {
                    if (param["task"]) {
                        console.log(JSON.stringify(JSON.parse(param["task"])));
                        this.editTaskId = (JSON.parse(param["task"]));
                        if(this.editTaskId == 0 )
                        {this.edithide = true;
                        this.addhide = false;
                        }
                        else{
                            this.edithide = false;
                            this.addhide = true;

                        }
                    }
                });
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        if(JSON.parse(localStorage.getItem("TaskDetailsFilters"))!=null)
        this.TaskDetails = JSON.parse(localStorage.getItem("TaskDetailsFilters"));



    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {


        this.getUsers();
        this.getStatus()

        if (this.addhide == true && this.edithide == false) {
        this.getMyTask();


        }
        else{
            debugger
            this.addEditMTask ={TaskName:"",AssignedTo:"",Status:2,TaskOwner:this.userDetail.SiteUserId,PlannedStartDate: moment(new Date()).format('DD/MM/YYYY'),PlannedEndDate:moment(new Date()).format('DD/MM/YYYY'),Comment:"",CompletionComment:""}

        }


                 }


    ngAfterViewInit() {

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });

        var today = moment().format('YYYY-MM-DD'); 
        
        $('.date').datetimepicker({
            format: 'DD/MM/YYYY',
            minDate:today        
        });

        this.addEditMTask.PlannedEndDate =  moment().format('DD/MM/YYYY'),
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });

        // setTimeout(() => {
        //     $('#teammultiselect').multiselect({
        //         enableFiltering: false,
        //         includeSelectAllOption: true,
        //         selectAllJustVisible: false,
        //     });

        //     $('#teammultiselect option').each(function () {
        //         if ($(this).attr('selected') == 'selected') {
        //         }
        //     });
        // }, 1000);

    }

    // public AddTeamFormLoad() {
    //     $('#btnAddTeamForm').trigger('click');
    // }


    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }




// public GetTaskLists(projectid){
//     this._httpService.ajaxPost('MyTask/GetTaskList',{"ProjectId":projectid,"logginUserId":this.userDetail.SiteUserId}).subscribe(
//         data => {
//             this.TaskItems = data["TaskList"];
//             if(this.addhide == true && this.edithide == false)
//             this.TaskItems = JSON.parse(JSON.stringify(this.TaskItems.filter(m => m.TaskId != this.addEditMTask.TaskId)));

//         }
//     );
// }



// public changeStatus(){

//     if( this.addEditMTask.Status==1)
//     this.addEditMTask.Status=2;

// }


// public changeStatusForTaskEnd(){

//   this.addEditMTask.Status=4;

// }

// changeStatusForReOpen(){

//     this.addEditMTask.Status=3;

// }
// CheckListCompleted(item,event){

//     if(event == true){
//         item.CompletedBy = this.userDetail.SiteUserId;
//         item.CompletedDate = null ;

//     }
//     else{
//         item.CompletedBy = null;
//         item.CompletedDate =null;

//     }


//  }
    public getUsers() {


        this._httpService.ajaxPost("Users/GetUsers",
        {
            "IsActive": this.constants.enumUserStatus["Active"],
            "Role": null,
            "Site": null,
            "Team": this.userDetail.TeamID,
            "UserId": this.userDetail.SiteUserId
       }).subscribe(
       data => {
           this.usersItems = data["Users"];
           if(this.userDetail.RoleId == this.constants.enumUserRole.Executive )
            {
                this.usersItems=  this.usersItems.filter( x=> x.SiteUser_Id == this.userDetail.SiteUserId);
            }
         } );

    }







     public getStatus() {
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["TaskStatusType"] }).subscribe(
             data => {

                 this.StatusItems = data["Parameter"];
                 this.StatusItems = this.StatusItems.filter(x=>x.Value != 1 && x.Value != 7);
        }
          );
      }


callFunction(){

    this.getUsers();

}

    public getMyTask() {
        this.showLoader = true;
        this._httpService.ajaxPost('MyTask/GetTask', { "TaskId": this.editTaskId}).subscribe(
            data => {
                this.myTask = data["MyTask"];
                this.addEditMTask = this.myTask[0];
                this.addEditMTask.PlannedStartDate =  moment(new Date(this.addEditMTask.PlannedStart)).format('DD/MM/YYYY');
                this.addEditMTask.PlannedEndDate = moment(new Date(this.addEditMTask.PlannedEndDate)).format('DD/MM/YYYY');

                // if(this.addEditMTask.TaskOwner==this.userDetail.SiteUserId || this.addEditMTask.CreatedBy ==this.userDetail.SiteUserId)
                // {   //this.IsSubmit =true;
                //     this.IsCreated =false
                //     this.IsStatusOpen = false
                //     console.log("dd"+this.IsCreated)
                // }
                // if(this.addEditMTask.Status==4)
                // {

                //     this.IsCreatedBy =true
                //     console.log("ww"+this.IsCreatedBy)
                // }

                // if(this.addEditMTask.Status ==4||this.addEditMTask.Status ==7)
                // {
                //     this.IsCompleted =true
                //     this.IsCreated =true
                //    // this.IsCreatedBy =true
                //    if(this.addEditMTask.Status ==7)
                //    this.IsStatusOpen = true

                //    if(this.addEditMTask.TaskOwner==this.userDetail.SiteUserId || this.addEditMTask.CreatedBy ==this.userDetail.SiteUserId)
                //    {     this.IsSubmit =true
                //    }
                //    else{
                //     this.IsSubmit =false
                // }
                // }



            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

     public CancelMyTask() {

         this._Router.navigateByUrl('/taskList');
         this.isAdd = true;
         this.addEditMTask = {};
     }




    public AddMyTask() {
debugger

            let objItem: any = {};
            objItem.TaskId =this.addEditMTask.TaskId;
            objItem.TaskName =this.addEditMTask.TaskName;
            objItem.AssignTo =this.addEditMTask.AssignedTo
            objItem.TaskOwner = this.userDetail.SiteUserId;
            objItem.PlannedStartDate =this.addEditMTask.PlannedEndDate;
            objItem.PlannedEndDate  =this.addEditMTask.PlannedEndDate;
            objItem.CompletionComment=this.addEditMTask.CompletionComment;
            if(this.editTaskId ==0 )
            objItem.Status     =  2;
            else
            objItem.Status     =  this.addEditMTask.Status;
           if(this.addEditMTask.Comment!= null && this.addEditMTask.Comment !=""){
            if(objItem.CompletionComment!= null && objItem.CompletionComment !="")
            objItem.CompletionComment =this.addEditMTask.CompletionComment +'&#13;&#10;&#13;&#10;'+this.addEditMTask.Comment+'&nbsp;&nbsp;'+'- commented by '+this.userDetail.Name;
            else
            objItem.CompletionComment= this.addEditMTask.Comment+'&nbsp;&nbsp;'+'-commented by '+this.userDetail.Name;
         }
           
            objItem.CreatedBy = this.userDetail.SiteUserId;
            objItem.ModifiedBy = this.userDetail.SiteUserId;

           // this.TaskDetails = {ProjectId:this.addEditMTask.ProjectId,ModuleId:this.addEditMTask.ModuleId,TaskTypeId:this.addEditMTask.TaskTypeId,AssignedTo:this.addEditMTask.AssignedTo};
            //localStorage.setItem("TaskDetailsFilters",JSON.stringify(this.TaskDetails));
            this.addEditMyTask(objItem);


        }




addEditMyTask(objItem) {


        if(this.validate(objItem))
        {
            this.showLoader = true;
        this._httpService.ajaxPost('MyTask/AddUpdateMyTask', objItem).subscribe(
            data => {

                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();

                   if( msg[0]!="warning")
                    {  this._Router.navigateByUrl('/taskList');}
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }

                },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );

        }

    }


    validate(item){
        var mandatory = "";
        var invalid = "";
        var functional = "";



               if(item.TaskName == "" || item.TaskName == null )
                {
                    mandatory = mandatory + "<br>TaskName";
                }

                if(item.PlannedEndDate == "" || item.PlannedEndDate == null)
                {
                    mandatory = mandatory + "<br>Due Date";
                }


                if(item.AssignTo == "" || item.AssignTo == null )
                {
                    mandatory = mandatory + "<br>Assign to";
                }


                if(item.Status == "" || item.Status == null )
                {
                    mandatory = mandatory + "<br>Status";
                }


        if (mandatory == "" && invalid == "" && functional == "") {
            return true;
        } else {
            var msg = "";
            if (mandatory != "") {
                msg = msg + "Please enter : " + mandatory;
                msg = msg + "<br>";
            }
            if (invalid != "") {
                msg = msg + "Please enter valid : " + invalid;
                msg = msg + "<br>";
            }
            if (functional != "") {
                msg = msg + functional;
            }
            this._sharedService.ShowMessage("error|" + msg);
        }
        return false;

    }
    DeletewarningTask(){

        $('#deletetask').modal('show');

    }
    DeleteWWWTask(){
  $('#deletetask').modal('hide');
         this.showLoader = true;
        this._httpService.ajaxPost('MyTask/DeleteWWWTask', this.editTaskId).subscribe(
            data => {

                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();

                   if( msg[0]!="warning")
                    {  this._Router.navigateByUrl('/taskList');}
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }

                },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );

        

    }
}






/** WEBPACK FOOTER **
 ** ./TypeScripts/Task/Task.component.ts
 **/